<template>
  <div class="app-container">
    <transition name="fade" mode="out-in">
      <keep-alive>
        <div>
          <Login v-if="showLogin" key="login" @switch-to-register="showLogin = false" @switch-to-management="showManagement = true" ref="login" />
          <Register v-else-if="!showLogin && !showManagement" key="register" @switch-to-login="showLogin = true" ref="register" />
          <UserManagement v-else key="management" @switch-to-login="showManagement = false; showLogin = true" />
        </div>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Login from './components/Login.vue';
import Register from './components/Register.vue';
import UserManagement from './components/UserManagement.vue';

export default {
  components: {
    Login,
    Register,
    UserManagement,
  },
  data() {
    return {
      showLogin: true, // 控制显示登录页面或注册页面
      showManagement: false, // 控制显示用户管理页面
    };
  },
  watch: {
    showLogin(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.login?.resetFields();
        });
      }
    },
    showManagement(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.$refs.login?.resetFields();
        });
      }
    }
  }
};
</script>

<style>
.app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-image: url('../src/tp.png'); /* 设置背景图片 */
  background-size: cover; /* 使背景图片覆盖整个容器 */
  background-position: center; /* 将背景图片居中 */
  background-repeat: no-repeat; /* 防止背景图片重复 */
  background-attachment: fixed; /* 背景图片固定，不随滚动条滚动 */
}

/* 添加淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
